import { Button } from '~/primitives/button';
import {
    Dialog,
    DialogContent,
    DialogDescription,
    DialogFooter,
    DialogHeader,
    DialogTitle,
} from '~/primitives/dialog';
import { getRouteApi } from '@tanstack/react-router';
import { ModalProps } from '~/util';
import { useAppForm } from '~/util/hooks/useAppForm';
import { useResettableState } from '~/util/hooks/useResettableState';

const Route = getRouteApi('/list');

const ListTimeMachineModal: React.FC<ModalProps> = ({ open, onOpenChange }) => {
    const time_machine = Route.useSearch({
        select: ({ time_machine }) => time_machine,
    });
    const navigate = Route.useNavigate();

    const [localDate, setLocalDate] = useResettableState(time_machine);

    const form = useAppForm({
        defaultValues: {
            time_machine: time_machine ?? new Date().toISOString().slice(0, 16),
        },
        listeners: {
            onChange: ({ formApi }) => {
                setLocalDate(formApi.state.values.time_machine);
            },
            onChangeDebounceMs: 500,
        },
    });

    const apply = () => {
        navigate({
            from: '/list/$levelid',
            search: (prev) => ({ ...prev, time_machine: localDate }),
            replace: true,
        });
        onOpenChange(false);
    };

    const reset = () => {
        setLocalDate(undefined);
        form.reset();
        navigate({
            from: '/list/$levelid',
            search: (prev) => ({ ...prev, time_machine: undefined }),
            replace: true,
        });
        onOpenChange(false);
    };

    return (
        <Dialog open={open} onOpenChange={onOpenChange}>
            <DialogContent className="w-xl">
                <DialogHeader>
                    <DialogTitle>Time Machine</DialogTitle>
                    <DialogDescription>
                        Enter the date you want to see the state of the list at.
                        Note that the earliest available date is August 17th
                        2022, as that is when the AREDL was first created.
                    </DialogDescription>
                </DialogHeader>
                <form.AppField name="time_machine">
                    {(field) => (
                        <field.DateTimeField
                            hideLabelAndErrors
                            className="hover:bg-background-dark mx-auto lg:ml-0"
                        />
                    )}
                </form.AppField>

                <DialogFooter className="mb-1">
                    <Button onClick={apply}>Apply</Button>
                    <Button
                        variant="secondary"
                        onClick={() => onOpenChange(false)}
                    >
                        Cancel
                    </Button>
                    <Button variant="destructive" onClick={reset}>
                        Reset
                    </Button>
                </DialogFooter>
            </DialogContent>
        </Dialog>
    );
};

export default ListTimeMachineModal;
